import React from 'react';
import { Box, Typography, Alert } from '@mui/material';

const NotFound: React.FC = () => {
  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="60vh"
      gap={3}
      px={3}
    >
      <Alert severity="error" sx={{ maxWidth: 500, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          404
        </Typography>
        <Typography variant="h6" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1">
          The page you're looking for doesn't exist or may have been moved.
        </Typography>
      </Alert>
    </Box>
  );
};

export default NotFound;
